module.exports = __webpack_public_path__ + "static/image/sustainability/img-happiness-1.ver2_0_2.png?b94b37d6";